/* Bellani Pets global script: drawers, focus trap, sticky header, money helper. ES2019, no deps. */
(function () {
  'use strict';

  var SETTINGS = window.BP_SETTINGS || {};
  var FOCUSABLE = [
    'a[href]', 'area[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', 'summary', 'iframe',
    '[tabindex]:not([tabindex="-1"])', '[contenteditable="true"]'
  ].join(',');

  /* Focus trap */
  var trap = { el: null, returnTo: null, handler: null };

  function getFocusable(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (node) {
      return node.offsetWidth > 0 || node.offsetHeight > 0 || node.getClientRects().length > 0;
    });
  }

  function releaseFocus() {
    if (trap.handler) document.removeEventListener('keydown', trap.handler, true);
    var back = trap.returnTo;
    trap.el = null;
    trap.returnTo = null;
    trap.handler = null;
    if (back && typeof back.focus === 'function' && document.contains(back)) {
      try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
    }
  }

  function trapFocus(el, initial) {
    if (!el) return;
    if (trap.el && trap.el !== el) {
      if (trap.handler) document.removeEventListener('keydown', trap.handler, true);
    } else if (!trap.returnTo) {
      trap.returnTo = document.activeElement;
    }
    if (!trap.returnTo) trap.returnTo = document.activeElement;
    trap.el = el;
    trap.handler = function (event) {
      if (event.key !== 'Tab' || !trap.el) return;
      var items = getFocusable(trap.el);
      if (!items.length) { event.preventDefault(); trap.el.focus(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || active === trap.el || !trap.el.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !trap.el.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trap.handler, true);
    var target = initial || getFocusable(el)[0] || el;
    window.requestAnimationFrame(function () {
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    });
  }

  /* Money formatting using shop.money_format */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;
    var fmt = format || SETTINGS.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var match = fmt.match(placeholder);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      default: value = withDelimiters(cents, 2);
    }
    /* Shopify money formats can contain HTML; strip tags for plain text output */
    return fmt.replace(placeholder, value).replace(/<[^>]*>/g, '');
  }

  /* Drawers: any [data-bp-drawer] with an id; openers use [data-bp-drawer-open="id"] */
  var openDrawerEl = null;
  var openerEl = null;

  function overlayFor(drawer) {
    return document.querySelector('[data-bp-overlay-for="' + drawer.id + '"]');
  }

  function setExpanded(id, value) {
    document.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (btn) {
      if (btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function openDrawer(drawer, opener) {
    if (typeof drawer === 'string') drawer = document.getElementById(drawer);
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer(openDrawerEl, true);
    openDrawerEl = drawer;
    openerEl = opener || document.activeElement;
    var overlay = overlayFor(drawer);
    if (overlay) overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.documentElement.classList.add('bp-no-scroll');
    setExpanded(drawer.id, true);
    trap.returnTo = openerEl;
    trapFocus(drawer);
    drawer.dispatchEvent(new CustomEvent('bp:drawer:open', { bubbles: true }));
  }

  function closeDrawer(drawer, silent) {
    if (typeof drawer === 'string') drawer = document.getElementById(drawer);
    drawer = drawer || openDrawerEl;
    if (!drawer) return;
    var overlay = overlayFor(drawer);
    if (overlay) overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    setExpanded(drawer.id, false);
    if (drawer === openDrawerEl) {
      openDrawerEl = null;
      document.documentElement.classList.remove('bp-no-scroll');
      if (!silent) releaseFocus();
      else { if (trap.handler) document.removeEventListener('keydown', trap.handler, true); trap.handler = null; trap.el = null; }
    }
    drawer.dispatchEvent(new CustomEvent('bp:drawer:close', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-bp-drawer-open]');
    if (opener) {
      event.preventDefault();
      var id = opener.getAttribute('data-bp-drawer-open');
      var drawer = document.getElementById(id);
      if (drawer && drawer.classList.contains('is-open')) closeDrawer(drawer);
      else openDrawer(drawer, opener);
      return;
    }
    var closer = event.target.closest('[data-bp-drawer-close]');
    if (closer) {
      var host = closer.closest('[data-bp-drawer]');
      if (!host && closer.hasAttribute('data-bp-overlay-for')) {
        host = document.getElementById(closer.getAttribute('data-bp-overlay-for'));
      }
      closeDrawer(host || openDrawerEl);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    /* The cart drawer owns its own Escape handling (bp-cart.js) */
    var cartDrawer = document.querySelector('[data-bp-cart-drawer]');
    if (cartDrawer && cartDrawer.classList.contains('is-open')) return;
    if (openDrawerEl && openDrawerEl.hasAttribute('data-bp-drawer')) {
      closeDrawer(openDrawerEl);
      return;
    }
    /* Close open desktop dropdowns */
    var open = document.querySelector('[data-bp-dropdown][open]');
    if (open) {
      open.removeAttribute('open');
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    }
  });

  /* Close the mobile menu if the viewport grows to desktop */
  var desktopMq = window.matchMedia('(min-width: 990px)');
  function onMq(e) {
    if (e.matches && openDrawerEl && openDrawerEl.id === 'bp-menu-drawer') closeDrawer(openDrawerEl, true);
  }
  if (desktopMq.addEventListener) desktopMq.addEventListener('change', onMq);
  else if (desktopMq.addListener) desktopMq.addListener(onMq);

  /* Desktop dropdowns: one open at a time, close on outside click */
  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (!el.matches || !el.matches('[data-bp-dropdown]') || !el.open) return;
    document.querySelectorAll('[data-bp-dropdown][open]').forEach(function (other) {
      if (other !== el) other.removeAttribute('open');
    });
  }, true);
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-bp-dropdown][open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });

  /* Sticky header: make the section wrapper sticky (fallback for no :has support) and mark scrolled state */
  function initHeader() {
    var header = document.querySelector('[data-bp-header]');
    if (!header) return;
    var wrapper = header.closest('.shopify-section') || header.parentElement;
    if (header.getAttribute('data-sticky') === 'true' && wrapper) {
      wrapper.classList.add('bp-header-section--sticky');
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;';
      document.body.prepend(sentinel);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
        }).observe(sentinel);
      }
    }
  }

  /* Keep any cart count in sync with bp-cart.js events */
  document.addEventListener('bp:cart:updated', function (event) {
    var cart = event.detail;
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-bp-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('data-empty');
      else el.setAttribute('data-empty', '');
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader);
  else initHeader();

  /* Theme editor: close drawers when sections reload */
  document.addEventListener('shopify:section:unload', function () { if (openDrawerEl) closeDrawer(openDrawerEl, true); });

  window.BP = window.BP || {};
  window.BP.trapFocus = trapFocus;
  window.BP.releaseFocus = releaseFocus;
  window.BP.formatMoney = formatMoney;
  window.BP.openDrawer = openDrawer;
  window.BP.closeDrawer = closeDrawer;
  window.BP.getFocusable = getFocusable;
})();
